import React from 'react';
import { Trans } from 'react-i18next';
import { Box, Link, Text } from '@nimbus-ds/components';
import { RenderByCountry } from 'commons/components/RenderByCountry';
import { TextByCountry } from 'commons/components/TextByCountry';
import {
  formatCuit,
  getCuitOrCuilLabel,
  useTranslationWithPrefix,
} from 'commons/utils';

interface InterfaceFiscalDocument {
  fiscalNumber: string;
}

const FiscalDocument = ({
  fiscalNumber,
}: InterfaceFiscalDocument): JSX.Element => {
  const { t } = useTranslationWithPrefix('configuration.personalData');

  return (
    <Box
      gap="4"
      display="flex"
      flexDirection="column"
      borderWidthX="none"
      borderTopWidth="none"
      borderBottomWidth="1"
      borderColor="neutral-surface"
      borderStyle="solid"
      paddingBottom="4"
    >
      <Box gap="2" display="flex" flexDirection="column">
        <TextByCountry
          color="neutral-textHigh"
          AR={`${getCuitOrCuilLabel(fiscalNumber)} ${t('registered')}`}
          BR={`${getCuitOrCuilLabel(fiscalNumber)} ${t('registered')}`}
          MX={`${t('rfc')} ${t('registered')}`}
        />
        <TextByCountry
          color="neutral-textHigh"
          AR={formatCuit(fiscalNumber)}
          BR={formatCuit(fiscalNumber)}
          MX={fiscalNumber}
        />
      </Box>
      <RenderByCountry
        AR={
          <Text data-testid="edit-cuit-text">
            <Trans
              t={t}
              i18nKey="editCuit.text"
              components={{
                a: (
                  <Link
                    as="a"
                    href={t('editCuit.href')}
                    appearance="primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {''}
                  </Link>
                ),
              }}
            />
          </Text>
        }
      />
    </Box>
  );
};

export default FiscalDocument;
